import React, { useEffect, useState } from 'react'
import {
  Box,
  Typography,
  Backdrop,
  Button,
  Grid,
  makeStyles,
  CircularProgress,
  Fade,
  TextField,
  Select,
  MenuItem,
  Snackbar
} from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { DoctorStore } from '../../stores'
import { NETWORK_STATUS } from '../../Constants'
import { useParams } from 'react-router'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Alert, Autocomplete } from '@material-ui/lab'
import useDebounce from '../../customHooks/useDebounce'
import { addLab } from '../../helper'
import swal from 'sweetalert'

const AddLabOrders = ({ open, handleClose, onSuccess }) => {
  const classes = useStyles()
  const params = useParams()
  const [report, setReport] = useState([])
  const [searchString, setSearchString] = useState('')
  const debouncedSearchTerm = useDebounce(searchString, 300)
  // const [fileNotFound, setFileNotFound] = useState(false)
  const [loading, setLoading] = useState(false)
  const [snackBarMessage, setSnackBarMessage] = useState({
    message: '',
    error: false
  })
  const handleSnackbarClose = () => {
    setSnackBarMessage({ message: '', error: false })
  }

  const { getLabRecordsNames } = DoctorStore.useStoreActions(actions => ({
    ...actions.patients
  }))

  const { networkStatus, lablist, labsFetchingStatus } =
    DoctorStore.useStoreState(state => ({
      ...state.patients
    }))

  const blobToBase64 = blob => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result.split(',', 2)[1])
      }
    })
  }

  // const submit = async values => {
  //   if (report.length) {
  //     const file = report[0]
  //     let fileResponse = await convertBase64(file)
  //     addLab({
  //       ...values,
  //       patientId: params.patient_id,
  //       appointmentId: params.appointment_id,
  //       reportName: file.name,
  //       report: fileResponse
  //     })

  //     setTimeout(() => {
  //       handleClose()
  //     }, 500)
  //     return
  //   }
  //   addLab({
  //     ...values,
  //     patientId: params.patient_id,
  //     appointmentId: params.appointment_id
  //   })

  //   setTimeout(() => {
  //     handleClose()
  //   }, 500)
  // }

  const submit = async values => {
    setLoading(true)
    try {
      const token = localStorage.getItem('dr_token')
      const pd_id = localStorage.getItem('pd_id')

      if (!token || !pd_id) {
        setSnackBarMessage({
          message: 'Missing authentication details.',
          error: true
        })
        return
      }

      const base64File = report.length ? await blobToBase64(report[0]) : ''

      const finalPayload = {
        pd_id,
        doc_type: 'LAB',
        appointment_id: params.appointment_id,
        report_date: new Date().toISOString(),
        file: base64File,
        file_name: base64File
          ? `${values.testName}${/(?:\.([^.]+))?$/.exec(report.name)?.[0]}`
          : '',
        tags: [
          { key: 'testname', value: values.testName },
          { key: 'instructions', value: values.instructions }
        ]
      }

      const response = await addLab(finalPayload, token)

      if (response?.success) {
        if (onSuccess) await onSuccess()
        setSnackBarMessage({
          message: response?.body || 'Lab report uploaded successfully.',
          error: false
        })
        console.log('kiran', response?.body)
      } else {
        setSnackBarMessage({
          message: response?.error || 'Lab report upload failed.',
          error: true
        })
        console.error('Lab report upload failed:', response?.error)
      }
    } catch (error) {
      setSnackBarMessage({
        message: error?.message || 'Unexpected error occurred.',
        error: true
      })
      console.error('Unexpected error:', error)
    } finally {
      setTimeout(() => {
        handleClose()
      }, 500)
      setLoading(false)
    }
  }

  // const handlelabsChange = (event, value) => {
  //   if (value?.type === 'others') {
  //     setFieldValue('type', value?.type)
  //   } else {
  //     setFieldValue('type', value?.lab_id)
  //   }
  //   setFieldValue('testName', value?.testname)
  // }

  const { values, handleChange, handleSubmit, errors, touched, setFieldValue } =
    useFormik({
      initialValues: {
        type: '',
        instructions: '',
        testName: ''
      },
      onSubmit: submit,
      validationSchema
    })

  useEffect(() => {
    getLabRecordsNames({
      table_config_search_string: searchString
    })
  }, [debouncedSearchTerm])

  const handleSearchChange = event => {
    setSearchString(event.target.value)
  }
  const handleFileChange = event => {
    // setFileNotFound(true)
    setReport(event.target.files)
  }

  const isError = (error, touched) => error && touched

  return (
    <>
      <Snackbar
        open={!!snackBarMessage.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={handleSnackbarClose}>
        <Alert
          onClose={handleSnackbarClose}
          severity={snackBarMessage.error ? 'error' : 'success'}>
          {snackBarMessage.message}
        </Alert>
      </Snackbar>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        className={classes.ModalHead}>
        <h3>Add New Lab Reports</h3>
        {/* <DialogTitle id="form-dialog-title" >
        Add New Lab Reports
      </DialogTitle> */}
        <DialogContent>
          <Box className={classes.ModalForm}>
            <form noValidate={true}>
              <Grid container spacing={3}>
                <Grid item xs={12} style={{ padding: '8px 0' }}>
                  {/* <Autocomplete
                  // multiple
                  options={lablist}
                  style={{ width: '100%' }}
                  getOptionLabel={option => {
                    if (option.type === 'others') {
                      let added = values.testName === option?.testname
                      if (added) {
                        return option?.testname
                      } else {
                        return option.title
                      }
                    }
                    if (option.inputValue) {
                      return option.title
                    }
                    return option?.testname
                  }}
                  loadingText="Loading..."
                  noOptionsText={
                    labsFetchingStatus ? 'Loading...' : 'No Options'
                  }
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  onChange={handlelabsChange}
                  filterOptions={(options, params) => {
                    const filtered = options
                    if (
                      options.length === 0 &&
                      !labsFetchingStatus &&
                      params.inputValue !== ''
                    ) {
                      filtered.push({
                        type: 'others',
                        title: `Add "${params.inputValue}"`,
                        testname: params.inputValue
                      })
                    }
                    return filtered
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      className={classes.Input}
                      label="Lab Record Name *"
                      name={'testName'}
                      value={values.testName}
                      // variant="outlined"
                      error={isError(errors.testName, touched.testName)}
                      helperText={
                        isError(errors.testName, touched.testName)
                          ? errors.testName
                          : null
                      }
                      loading={labsFetchingStatus}
                      onChange={handleSearchChange}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {labsFetchingStatus ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        )
                      }}
                    />
                  )}
                /> */}
                  <TextField
                    className={classes.Input}
                    label="Lab Record Name *"
                    name="testName"
                    fullWidth
                    value={values.testName}
                    onChange={e => {
                      const inputValue = e.target.value
                      setFieldValue('testName', inputValue)
                      setFieldValue('type', 'others') // Always set to 'others'
                    }}
                    error={isError(errors.testName, touched.testName)}
                    helperText={
                      isError(errors.testName, touched.testName)
                        ? errors.testName
                        : null
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} style={{ padding: '8px 0' }}>
                  <Box className={classes.InputCol}>
                    <TextField
                      multiline={true}
                      className={classes.textArea}
                      variant={'outlined'}
                      label="Instructions *"
                      name={'instructions'}
                      error={isError(errors.instructions, touched.instructions)}
                      helperText={
                        isError(errors.instructions, touched.instructions)
                          ? errors.instructions
                          : null
                      }
                      value={values.instructions}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} style={{ padding: '8px 0' }}>
                  <input
                    accept="image/*,.pdf,.doc,.docx"
                    className={classes.uploadInput}
                    id="file-input"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="file-input" style={{ width: '100%' }}>
                    <Button
                      variant="contained"
                      color="#111d4e"
                      size="large"
                      className={classes.button}
                      component="span"
                      startIcon={<CloudUploadIcon />}
                      style={{ width: '100%' }}>
                      Upload Report
                    </Button>
                  </label>
                  {/* {fileNotFound == false ? (
                  <Typography className={classes.error}>
                    File is mandatory
                  </Typography>
                ) : (
                  ''
                )} */}
                  {report.length ? (
                    <Typography className={classes.fileUploaded}>
                      File Uploaded
                    </Typography>
                  ) : null}
                </Grid>
              </Grid>
            </form>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: '20px 40px' }}>
          <button
            onClick={handleClose}
            className={classes.modalSecondaryButton}>
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className={classes.modalPrimaryButton}
            style={{ backgroundColor: loading ? 'lightblue' : '#111d4e' }}>
            Add
          </button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const validationSchema = yup.object().shape({
  type: yup.string().trim().required('Test name is required'),
  testName: yup.string().trim().required('Test name is required'),
  instructions: yup
    .string()
    .trim()
    .required('Instructions are required')
    .max(250, 'You have exceeded the character limit')
})

const convertBase64 = file => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result)
    }

    fileReader.onerror = error => {
      reject(error)
    }
  })
}

const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error.main
  },
  fileUploaded: {
    color: theme.palette.success.main,
    margin: '8px 0'
  },
  uploadInput: {
    display: 'none'
  },
  textArea: {
    width: '100%',
    '@media (max-width:767px)': {
      width: '99%',
      marginLeft: '2px'
    }
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  formControl: {
    width: '100%'
  },
  textField: {
    width: '100%'
  },
  select: {
    width: '100%'
  },
  InputCol: {
    '& .MuiInput-root': {
      width: '100%'
    }
  },
  Textara: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    padding: '10px'
  },
  ModalBox: {
    width: '500px',
    background: '#fff',
    padding: '0px',
    '@media (max-width:767px)': {
      width: '100%'
    },
    // height:'400px',
    '& h2': {
      textAlign: 'left',
      fontSize: '20px',
      color: '#fff',
      background: '#3f4b79',
      padding: '10px 20px',
      '& span': {
        float: 'right',
        color: '#fff',
        cursor: 'pointer'
      }
    }
  },
  ModalForm: {
    width: '100%',
    padding: '20px',
    '@media (max-width:767px)': {
      height: 'auto',
      padding: '10px',
      overflowY: 'hidden',
      overflowX: 'hidden',
      width: '98%'
    }
  },
  DownloadBtn: {
    width: '120px',
    background: '#3f4b79',
    height: '40px',
    textAlign: 'center',
    color: '#fff',
    lineHeight: '40px',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '50px',
    border: 'none',
    cursor: 'pointer',
    margin: '20px auto 0',
    display: 'block'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalPrimaryButton: {
    backgroundColor: '#111d4e',
    padding: '5px 20px',
    borderRadius: '40px',
    color: '#fff',
    cursor: 'pointer',
    height: '40px',
    fontSize: '12px'
  },
  modalSecondaryButton: {
    backgroundColor: '#e4e4e4',
    padding: '5px 20px',
    borderRadius: '40px',
    color: '#111d4e',
    cursor: 'pointer',
    height: '40px',
    fontSize: '12px'
  },
  ModalHead: {
    width: '450px',
    margin: '0px auto',
    fontFamily: 'Poppins',
    '@media (max-width:767px)': {
      width: '100%'
    },
    '& h3': {
      padding: '15px 24px 10px',
      fontSize: '18px',
      marginBottom: '0px',
      borderBottom: '1px #ccc solid',
      fontWeight: '600'
    }
  },
  error: {
    color: 'red',
    fontSize: '12px',
    position: 'absolute'
  }
}))

export default AddLabOrders
